import {
  ABG_NO_DESTINATION_NOTE_FOR_RA,
  ABG_REPLACEMENT_CAR_COMMENT, ABG_TRANSPORTATION_COMMENT
} from "../../app-consts/appConstants";

export function processNoLocationCommentUpdate(
  existingComment: string,
  newPayload: string,
): string {
  const baseComment = ABG_NO_DESTINATION_NOTE_FOR_RA
  // Handle BASE_COMMENT payload
  if (newPayload === baseComment) {
    if (existingComment.includes(baseComment)) {
      return existingComment;
    }
    return baseComment + (existingComment ? `, ${existingComment}` : "");
  }

  if (!newPayload || newPayload.trim() === "") {
    if (!existingComment) {
      return "";
    }
    if (existingComment.includes(baseComment)) {
      // Extract non-base comments
      const parts = existingComment.split(", ");
      const nonBaseComments = parts.filter(part =>
        part !== baseComment &&
        (part === ABG_REPLACEMENT_CAR_COMMENT || part === ABG_TRANSPORTATION_COMMENT)
      );
      return nonBaseComments.join(", ");
    }
    return existingComment;
  }

  return newPayload;
}
